(function() { window.GUID_d5d65de5_93fc_4542_b933_39879722df70 = { getGuid: function() { return "d5d65de5-93fc-4542-b933-39879722df70"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            class Base {
                constructor(mainHelper) {
                    this.mainHelper = mainHelper;
                    this.disposed = false;
                }
                Dispose() {
                    if (!this.disposed) {
                        this.disposed = true;
                        this.OnDispose();
                        this.disposed = false;
                    }
                }
            }
            ImageCropperAddons.Base = Base;
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=base-image-cropper-addons.js.map
